import { Link } from '@issuu/ixu-react';
import * as React from 'react';
import styled from 'styled-components';
const CardFrame = styled.div `
    flex: '0 0';
    min-height: 200px;
    padding: 0 8px;
`;
const DocumentLink = styled(Link) `
    display: block;
`;
const CoverFrame = styled.div `
    position: relative;
    height: 100%;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    transition: box-shadow 0.15s;

    ::before {
        background-image: linear-gradient(
            -90deg,
            transparent 4%,
            hsla(0, 0%, 100%, 0.2) 61%,
            hsla(0, 0%, 100%, 0.4) 85%,
            hsla(0, 0%, 74%, 0) 96%
        );
        content: '';
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.77;
        pointer-events: none;
        position: absolute;
        transition: opacity 0.15s;
    }
`;
const CoverImage = styled.img `
    width: 100%;
    height: 100%;
`;
export const Cover = ({ title, imageUrl }) => {
    return (React.createElement(CardFrame, null,
        React.createElement(DocumentLink, null,
            React.createElement(CoverFrame, null,
                React.createElement(CoverImage, { alt: `Cover of "${title}"`, src: imageUrl })))));
};
//# sourceMappingURL=Cover.js.map